import type { RelationshipsViewSettings } from '../types';

// TODO: distinct view-settings shapes per mode (viewpoint/workspace) are now
// straightforward to introduce. Derive each mode's partition keys from the
// keys of its respective default const —
// DEFAULT_VIEWPOINT_MODE_SETTINGS[ViewIds.RELATIONSHIPS_3] and
// DEFAULT_WORKSPACE_MODE_SETTINGS[ViewIds.RELATIONSHIPS_3].

export const SOURCE_DATA_PARTITION_KEYS = [
  'depthOfRelationship',
  'includeOutgoingReferenceTypeNames',
  'includeIncomingReferenceTypeNames',
  'showOnlyConnectedComponents',
  'onViewSettingsUpdate',
  'incomingDegreesOfRelationship',
  'outgoingDegreesOfRelationship',
  'activeDiffMode',
  'useNewGrouping',
] as const satisfies readonly (keyof RelationshipsViewSettings)[];

export const COLLAPSED_GROUP_IDS_PARTITION_KEYS = [
  'collapsedGroupIds',
] as const satisfies readonly (keyof RelationshipsViewSettings)[];

export const RENDERING_DATA_PARTITION_KEYS = [
  'bundleRelationships',
  'highlightDisconnectedComponents',
  'lastClickedNodeId',
] as const satisfies readonly (keyof RelationshipsViewSettings)[];

export const UI_PROPS_PARTITION_KEYS = [
  'isLegendActive',
  'fullScreen',
] as const satisfies readonly (keyof RelationshipsViewSettings)[];

export type SourceDataSettings = Pick<
  RelationshipsViewSettings,
  (typeof SOURCE_DATA_PARTITION_KEYS)[number]
>;
export type CollapsedGroupIdsSettings = Pick<
  RelationshipsViewSettings,
  (typeof COLLAPSED_GROUP_IDS_PARTITION_KEYS)[number]
>;
export type RenderingDataSettings = Pick<
  RelationshipsViewSettings,
  (typeof RENDERING_DATA_PARTITION_KEYS)[number]
>;
export type UiPropsSettings = Pick<
  RelationshipsViewSettings,
  (typeof UI_PROPS_PARTITION_KEYS)[number]
>;

/** Triggers on source-data key changes; `collapsedGroupIds` joins via `withLatestFrom`. */
export type ViewSettingsForModelSourceData = SourceDataSettings &
  CollapsedGroupIdsSettings;

/** `collapsedGroupIds` feeds both partitions; here it joins via `combineLatest`. */
export type ViewSettingsForRenderingData = CollapsedGroupIdsSettings &
  RenderingDataSettings;
